// eslint-disable-next-line no-restricted-imports
import { type PostHogConfig } from 'posthog-js';
// eslint-disable-next-line no-restricted-imports
import { PostHogProvider as PostHogSDKProvider } from 'posthog-js/react';
import { type ReactNode } from 'react';

import { isDefined } from 'common';

// Since the deploy script isn't run locally, we need to hardcode here to connect to dev
const DEV_POSTHOG_KEY = 'phc_gtEkpiKk98dZymmUrj0JnxbbwzHmAZvlhgxHUMYoGKj';
const POSTHOG_HOST = 'https://us.i.posthog.com';
const POSTHOG_KEY =
  import.meta.env.MODE === 'development' ? DEV_POSTHOG_KEY : import.meta.env.VITE_POSTHOG_KEY;

const postHogOptions: Partial<PostHogConfig> = {
  api_host: POSTHOG_HOST,
  defaults: '2025-05-24',
  autocapture: false,
  capture_performance: false,
  disable_session_recording: true,
  capture_pageview: false,
  capture_pageleave: false,
};

interface PostHogProviderProps {
  children: ReactNode;
}

export function PostHogProvider(props: PostHogProviderProps) {
  // TODO: do not initialize provider if in CI environment
  if (!isDefined(POSTHOG_KEY)) {
    console.warn('PostHog disabled: missing VITE_POSTHOG_KEY');
    return props.children;
  }
  return (
    <PostHogSDKProvider apiKey={POSTHOG_KEY} options={postHogOptions}>
      {props.children}
    </PostHogSDKProvider>
  );
}
